/* eslint-disable */

export const protobufPackage = "Reality.Reality.Api";

export enum WebUserFeedbackPageType {
  WEB_USER_FEEDBACK_PAGE_TYPE_UNKNOWN = 0,
  WEB_USER_FEEDBACK_PAGE_TYPE_NOTICE = 1,
  WEB_USER_FEEDBACK_PAGE_TYPE_EVENT = 2,
  UNRECOGNIZED = -1,
}

export function webUserFeedbackPageTypeFromJSON(object: any): WebUserFeedbackPageType {
  switch (object) {
    case 0:
    case "WEB_USER_FEEDBACK_PAGE_TYPE_UNKNOWN":
      return WebUserFeedbackPageType.WEB_USER_FEEDBACK_PAGE_TYPE_UNKNOWN;
    case 1:
    case "WEB_USER_FEEDBACK_PAGE_TYPE_NOTICE":
      return WebUserFeedbackPageType.WEB_USER_FEEDBACK_PAGE_TYPE_NOTICE;
    case 2:
    case "WEB_USER_FEEDBACK_PAGE_TYPE_EVENT":
      return WebUserFeedbackPageType.WEB_USER_FEEDBACK_PAGE_TYPE_EVENT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return WebUserFeedbackPageType.UNRECOGNIZED;
  }
}

export function webUserFeedbackPageTypeToJSON(object: WebUserFeedbackPageType): string {
  switch (object) {
    case WebUserFeedbackPageType.WEB_USER_FEEDBACK_PAGE_TYPE_UNKNOWN:
      return "WEB_USER_FEEDBACK_PAGE_TYPE_UNKNOWN";
    case WebUserFeedbackPageType.WEB_USER_FEEDBACK_PAGE_TYPE_NOTICE:
      return "WEB_USER_FEEDBACK_PAGE_TYPE_NOTICE";
    case WebUserFeedbackPageType.WEB_USER_FEEDBACK_PAGE_TYPE_EVENT:
      return "WEB_USER_FEEDBACK_PAGE_TYPE_EVENT";
    case WebUserFeedbackPageType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
